module.exports = __webpack_public_path__ + "static/media/Beacon_Icon_Logo.96aea339.svg";